export default "__VITE_ASSET__1yhCYU_P__"